export default {

  REMOVE_EXPENSEPRODUCT(state, idexpense) {
    const ItemIndex = state.expense.expenselines.findIndex((p) => p.id === idexpense)
    state.expense.expenselines.splice(ItemIndex, 1)
  },
  CREATE_EXPENSEPRODUCT(state, item) {
    state.expense.expenselines.unshift(item)
  },
  UPDATE_EXPENSEPRODUCT(state, expenseproduct) {
    const expenseproductsIndex = state.expense.expenselines.findIndex((p) => p.id === expenseproduct.id)
    Object.assign(state.expense.expenselines[expenseproductsIndex], expenseproduct)
  },
  SET_EXPENSEPRODUCTS(state, expenselines) {
    state.expenselines = expenselines
  },
  SET_EXPENSEPRODUCTSS(state, expenselines) {
    state.expense.expenselines = expenselines
  },
  SET_EXPENSE(state, expense) {
    state.expense = expense
  },
  SET_EXPENSESDASHBOARD(state, expensesdashboard) {
    state.expensesdashboard = expensesdashboard
  },
  SET_EXPENSES(state, expenses) {
    state.expenses = expenses
  },
  SET_ADDRESSBILLING(state, addressbilling) {
    state.addressbilling = addressbilling
  },
  SET_ADDRESSDELIVERY(state, addressdelivery) {
    state.addressdelivery = addressdelivery
  },
  SET_PRODUCTLISTPDF(state, productlistpdf) {
    state.productlistpdf = productlistpdf
  },
  CREATE_INVOICEATTACHED(state, item) {
    state.invoiceattached.unshift(item)
  },
  REMOVE_INVOICEATTACHED(state, invoiceattach) {
    const invoiceattachIndex = state.invoiceattached.findIndex((p) => p.id === invoiceattach.id)
    state.invoiceattached.splice(invoiceattachIndex, 1)
  },
  UPDATE_INVOICEATTACHED(state, invoiceattach) {
    const invoiceattachIndex = state.invoiceattached.findIndex((p) => p.id === invoiceattach.id)
    Object.assign(state.invoiceattached[invoiceattachIndex], invoiceattach)
  },
  SET_INVOICEATTACHED(state, invoiceattached) {
    state.invoiceattached = invoiceattached
  },
  SET_PEOPLE_LIST(state, peoplelist) {
    state.peoplelist = peoplelist
  },
  SET_M3DIFFERENCE(state, m3difference) {
    state.m3difference = m3difference
  },
  SET_RONDIFFERENCE(state, rondifference) {
    state.rondifference = rondifference
  },
  SET_EURDIFFERENCE(state, eurdifference) {
    state.eurdifference = eurdifference
  },
  SET_OPERATIONS(state, operations) {
    state.operations = operations
  },
  SET_OPERATIONPRODUCTS(state, operationproducts) {
    state.operationproducts = operationproducts
  },
  CREATE_OPERATIONS_PRODUCTS(state, item) {
    state.operationproducts.unshift(item)
  },
  UPDATE_OPERATIONPRODUCTS(state, operationproduct) {
    const productIndex = state.operationproducts.findIndex((p) => p.id === operationproduct.id)
    Object.assign(state.operationproducts[productIndex], operationproduct)
  },
  REMOVE_OPERATIONPRODUCTS(state, productId) {
    const ItemIndex = state.operationproducts.findIndex((p) => p.id === productId)
    state.operationproducts.splice(ItemIndex, 1)
  },
  SET_OPERATION(state, operation) {
    state.operation = operation
  },
  UPDATE_OPERATION(state, operation) {
    const operationIndex = state.operations.findIndex((p) => p.id === operation.id)
    Object.assign(state.operations[operationIndex], operation)
  },
  CREATE_OPERATION(state, operation) {
    state.operation = operation
  },
  CREATE_TRANSPORT(state, operation) {
    state.operation = operation
  }
}
